import React from 'react';
import { UserIcon } from '@root/styles/icons';
import { useTranslations } from '@lang';
import { useRouter } from 'shared-routing';
import { Routes } from '@common/constants';
import { Item } from '../../common';
import { IconWrapper } from './AccountMenu.styles';
import { StyledHeader } from '../Items.styles';

const { SIGNIN, MY_ACCOUNT } = Routes;

export type AccountMenuProps = {
  isLoggedIn: boolean;
};

export const AccountMenu: React.FC<AccountMenuProps> = ({ isLoggedIn }) => {
  const { t } = useTranslations();
  const router = useRouter();
  return (
    <>
      <StyledHeader>{t('common.myAccount')}</StyledHeader>
      <Item
        message={t('flynav.signin')}
        display={!isLoggedIn}
        label={
          <IconWrapper>
            <UserIcon />
          </IconWrapper>
        }
        route={`${SIGNIN}?redirectTo=${router.asPath}`}
      />
      <Item
        message={t('common.myAccount')}
        display={isLoggedIn}
        label={
          <IconWrapper>
            <UserIcon />
          </IconWrapper>
        }
        route={MY_ACCOUNT}
      />
    </>
  );
};
